import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import { CompanyInterface } from "../../Entity/Entities/Company/CompanyInterface";
import Constants from "../../Action/Constants";

class CompanyUpdateWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const id = parseInt(this.component.props.params.id, 10);
    const company = this.component.props.app.companies.filter(
      (company: CompanyInterface) => company.id === id
    )[0];

    if (!!company) {
      return this.component.initializePage(company);
    } else {
      this.component.props.dispatch({
        type: Constants.GLOBAL_COMPANY_FOR_COMPANY_DETAILS_PAGE,
        payload: {
          companyId: id,
        },
        onSuccess: (company: CompanyInterface) => {
          return this.component.initializePage(company);
        },
        onError: this.component.redirectBack
      });
    }
  }
}

export default new CompanyUpdateWillMount();
